import { connect } from 'react-redux';
import { RouteComponentProps } from "react-router";
import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { ApplicationState } from "../../store";
import { TeamRole } from '../../store/Models/UserContext';
import Layout from "../Layout";


type RegulationLibraryProps =
    RouteComponentProps &
    ToxnotComponentProperties & {
        appServices: any;
    };

class RegulationLibrary extends ToxnotSignInRequiredComponent<RegulationLibraryProps> {
    constructor(props: RegulationLibraryProps) {
        super(props);
    }

    protected getDisallowedRoles(): TeamRole[] {
        return [];
    }

    protected renderConcreteComponent(): JSX.Element | null {

        const userContext = this.getUserContext();

        if (!userContext?.userCapabilities.regulationsEnabled) {
            return (
                <Layout>
                    <div className="tn-section text-center">
                        <p>{this.localizeString("You don't have access to view Regulation pages")}</p>
                    </div>
                </Layout>
            );
        }

        const config = this.props.appServices.config;
        if (!config) {
            console.error('Config is not defined');
            return <div>Config is not available</div>;
        }

        return (
            <Layout>
                <pfas-regulation-library
                    id="regulationMfe"
                    bff-base-url={`${config.regulationBffBaseUrl}`}
                    mfe-base-url={`${config.regulationLibraryBaseUrl}`}
                    title-regulation-mfe=""
                    regulation-details-url="/RegulationDetails/{key}"
                    locale={`${this.props.appServices.userContext.cultureName}`}
                ></pfas-regulation-library>
            </Layout>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(RegulationLibrary as any);
